import React from 'react';
import PropTypes from 'prop-types';

const ChevronLeft = ({color = 'currentColor', ...props}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 7 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.50016 9.1665L1.3335 4.99984L5.50016 0.833171"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ChevronLeft.propTypes = {
  color: PropTypes.string,
};

export default ChevronLeft;
